import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography, Paper } from '@mui/material';
import TemplatePanel from './signing/TemplatePanel';
import PacketPanel from './signing/PacketPanel';
import ActiveFormsPanel from './signing/ActiveFormsPanel';

const DocumentSigningDashboard = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Typography variant="h4" gutterBottom>
        Document Signing
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 780 }}>
        Author reusable templates, orchestrate packets to routing lists, and monitor every
        outstanding signature from a single hub. Each tab focuses on a different stage of the
        signing lifecycle.
      </Typography>

      <Paper elevation={3}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          variant="fullWidth"
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label="Templates" />
          <Tab label="Packets" />
          <Tab label="Active Forms" />
        </Tabs>
        <Box sx={{ p: { xs: 2, md: 3 } }}>
          {activeTab === 0 && <TemplatePanel />}
          {activeTab === 1 && <PacketPanel />}
          {activeTab === 2 && <ActiveFormsPanel />}
        </Box>
      </Paper>
    </Box>
  );
};

export default DocumentSigningDashboard;
